// extracted by mini-css-extract-plugin
export var activeFilterButton = "_of-c";
export var backButton = "_of-4";
export var backIcon = "_of-5";
export var chevronShortcut = "_of-6";
export var container = "_of-1";
export var editor = "_of-8";
export var editorWrapper = "_of-7";
export var prefix = "_of-2";
export var searchIcon = "_of-3";
export var suffix = "_of-9";
export var suffixContent = "_of-a";
export var suffixText = "_of-b";
export var wrapper = "_of-0";